export const enum ApiClientMode {
    PROD = 'PROD',
    TEST = 'TEST',
}

export const enum ApiClientScope {
    orders_read = 'orders_read',
    orders_write = 'orders_write',
}

export type ApiClient = {
    _id: string;
    organization: string;
    name: string;
    clientId: string;
    mode: ApiClientMode;
    scopes: ApiClientScope[];
    disabled: boolean;
    lastUsedAt?: string;
    secretLastRotatedAt: string;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
};

export type ApiClientWithSecret = {
    apiClient: ApiClient;
    clientSecret: string;
};

export type CreateApiClientInput = {
    organization: string;
    name: string;
    mode: ApiClientMode;
    scopes: ApiClientScope[];
};
